import { useContext, useEffect, useMemo } from 'react';

import { ValidationContext, ValidationContextType, ValidationType } from '../validations/ValidationContext';

type ValidationPropsType = {
    name: string
    validations: ValidationType | ValidationType[]
};

export default function useValidation({ name, validations = [] }: ValidationPropsType) {
    const validation = useContext<ValidationContextType>(ValidationContext);

    // Convert validations to an array and memoize to only change when validations change.
    const validationsArray = useMemo(() => {
        return Array.isArray(validations)
            ? validations
            : [validations];
    }, [validations]);
    // Stringify validations to detect changes in the validation array
    const validationString = useMemo(() => JSON.stringify(validationsArray), [validationsArray]);

    useEffect(() => {
        const active = !!(validation);

        if (active) {
            validationsArray.forEach((v) => {
                if (v && v.type) {
                    validation(name, v.type).validate(v.isValid);
                }
            });
        }

        return () => {
            if (active) {
                validationsArray.forEach((v) => {
                    if (v && v.type) {
                        validation(name, v.type).clear();
                    }
                });
            }
        };
        // Disabling typecheck for dependency array to prevent unnecessary re-renders
        // eslint-disable-next-line
    }, [name, validationString, validation]);

    return validationsArray.some((v) => !v.isValid);
}
